// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__WNvUy","large":"styles_large__gU0lb"};